import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import LightTooltip from 'src/common/components/styled/LightTooltip';
import { IVisibilityFilter } from 'src/interfaces/PageBlock';
import VisibilityRuleBuilder from 'src/pages/Dashboard/System/Pages/components/VisibilityRuleBuilder';

interface Props {
  value?: IVisibilityFilter;
  onChange: (value: IVisibilityFilter | undefined) => void;
  showSignupPresets?: boolean;
}

export default function BlockVisibilityRulesButton({
  value,
  onChange,
  showSignupPresets = false,
}: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasRules = (value?.rules?.length ?? 0) > 0;

  return (
    <>
      <LightTooltip title={t('system.pages.visibilityRules')} placement="top">
        <IconButton
          size="small"
          aria-label={t('system.pages.visibilityRules')}
          onClick={() => setOpen(true)}
          color={hasRules ? 'primary' : 'default'}
        >
          <VisibilityOutlinedIcon fontSize="small" />
        </IconButton>
      </LightTooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t('system.pages.visibilityRules')}</DialogTitle>
        <DialogContent dividers>
          <VisibilityRuleBuilder
            value={value}
            onChange={onChange}
            showSignupPresets={showSignupPresets}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{t('base.close')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
